import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="navbar">
      <Link to="/" className="nav-brand">ARIA SOOHYUN JO</Link>
      <div className={`nav-menu ${isOpen ? 'active' : ''}`}>
        <Link to="/about" className="nav-item">About</Link>
        <Link to="/events" className="nav-item">Events</Link>
        <Link to="/repertoire" className="nav-item">Repertoire</Link>
        <Link to="/photos" className="nav-item">Photos</Link>
        <Link to="/contact" className="nav-item">Contact</Link>
      </div>
      <div className="hamburger" onClick={() => setIsOpen(!isOpen)}>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </nav>
  );
}

export default Navbar;
